'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hamburger = void 0;
const $ = require("jquery");
class Hamburger {
    constructor() {
        if ($('.bulletHamburger').length === 0)
            return;
        $('.trigHamburger').on('click', (e) => {
            e.stopPropagation();
            const isOpen = $('.bulletHamburger').attr('data-is-open');
            if (isOpen === 'false') {
                $('.bulletHamburger').attr('data-is-open', 'true');
                $('.trigHamburger').attr('data-is-open', 'true');
                $('body').css('height', '100vh').css('overflow', 'clip');
            }
            else {
                $('.bulletHamburger').attr('data-is-open', 'false');
                $('.trigHamburger').attr('data-is-open', 'false');
                $('body').css('height', 'auto').css('overflow', 'revert');
            }
        });
        $(document).on('click', (e) => {
            const isOpen = $('.bulletHamburger').attr('data-is-open');
            if (isOpen === 'false')
                return;
            if ($(e.target).closest('.paramHamburger').length > 0)
                return;
            // 外側クリック → 閉じる
            $('.bulletHamburger').attr('data-is-open', 'false');
            $('.trigHamburger').attr('data-is-open', 'false');
            $('body').css('height', 'auto').css('overflow', 'revert');
        });
    }
}
exports.Hamburger = Hamburger;
exports.default = Hamburger;
